import { DocumentSnapshot } from "@atgof-firebase/firebase";
import React, { ReactNode } from "react";
import { LanguageContext } from "../common/language";
import FieldsRow from "./fields/FieldsRow";
import { View } from "react-native";
import FixtureLabel from "../common/FixtureLabel";
import { isCharacterCategory, SheetCategory } from "../common/sheet";
import { ApplicandsSelector } from "./ApplicandsSelector";
import { useFieldSpecs } from "../data/useFieldSpecs";
import { UserInkColour } from "@atgof-common/membership";
import ErrorBoundary from "./ErrorBoundary";
import { ApplicandKind, kindOfApplicand } from "@atgof-common/applicand";

export function SheetSection({
  title,
  children,
  small,
}: {
  title: string;
  children: ReactNode;
  small?: boolean;
}) {
  if (!children) return null;
  return (
    <View style={{ marginBottom: small ? 0 : 16 }}>
      <FixtureLabel
        style={{ marginBottom: small ? 0 : 4, fontSize: small ? 16 : 20 }}
        text={title}
      />
      {children}
    </View>
  );
}

export function SheetSections({
  doc,
  category,
  readonly,
  docIsApplicand,
  inkColours,
}: {
  doc: DocumentSnapshot | undefined;
  category: SheetCategory | undefined;
  readonly?: boolean;
  docIsApplicand?: boolean;
  inkColours?: UserInkColour[];
}) {
  const { ph } = React.useContext(LanguageContext);
  const fieldSpecs = useFieldSpecs();
  if (!(category && doc)) return null;
  const sections = fieldSpecs[category];
  const sectionKs = Object.keys(sections || {});
  const concise = readonly;
  const docApplicantKind = docIsApplicand
    ? kindOfApplicand(doc.ref)
    : undefined;
  const applicandKinds: ApplicandKind[] = (
    category === "arts"
      ? ["prop"]
      : isCharacterCategory(category)
        ? ["look", "prop"]
        : []
  ).filter((k) => !(k === "prop" && "prop" === docApplicantKind)) as any;
  return (
    <View style={{ gap: 8 }}>
      {doc &&
        applicandKinds.map((applicandKind) => (
          <View key={applicandKind} style={{ margin: 4 }}>
            <ErrorBoundary>
              <ApplicandsSelector
                applicandKind={applicandKind}
                doc={doc}
                readonly={readonly}
                docIsApplicand={docIsApplicand}
              />
            </ErrorBoundary>
          </View>
        ))}
      {concise && sectionKs.length == 1 ? (
        <FieldsRow
          category={category}
          fields={sections![sectionKs[0]]}
          doc={doc}
          readonly={readonly}
          inkColours={inkColours}
        />
      ) : (
        sectionKs.map((section) => (
          <SheetSection
            key={section}
            title={ph(section) as string}
            small={concise}
          >
            <FieldsRow
              category={category}
              fields={sections![section]}
              doc={doc}
              readonly={readonly}
              inkColours={inkColours}
            />
          </SheetSection>
        ))
      )}
    </View>
  );
}
